import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=10fade13"
import script from "./Selector.vue?vue&type=script&lang=js"
export * from "./Selector.vue?vue&type=script&lang=js"
import style0 from "./Selector.vue?vue&type=style&index=0&id=10fade13&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10fade13')) {
      api.createRecord('10fade13', component.options)
    } else {
      api.reload('10fade13', component.options)
    }
    module.hot.accept("./Selector.vue?vue&type=template&id=10fade13", function () {
      api.rerender('10fade13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/inputs/Selector.vue"
export default component.exports